import { Port } from "reaflow";
import CustomEdgeButton from "./CustomEdgeButton";
import { TERMINAL_END_NAME } from "../../../flow/nodes/mapper/constants";

type CustomPortProps = {
  onClick: any;
  onDeleteClick: any;
  nodeProperties: any;
};

const CustomPort = ({
  onClick,
  onDeleteClick,
  nodeProperties,
  ...restProps
}: CustomPortProps) => {
  const portVariant =
    ["SWITCH", "FORK_JOIN"].includes(nodeProperties.data.task.type) &&
    // @ts-ignore
    restProps.properties.side === "SOUTH"
      ? "ADD_DELETE"
      : "ADD";

  const isEndTerminal = nodeProperties.data.task.name === TERMINAL_END_NAME;

  return (
    <Port {...restProps} style={{ display: "none" }}>
      {(event) => {
        return (
          !isEndTerminal && (
            // @ts-ignore
            <CustomEdgeButton
              {...event}
              variant={portVariant}
              hidden={true}
              onClick={(clkEvent) => onClick(clkEvent, restProps)}
              onDeleteClick={(clkEvent) => onDeleteClick(clkEvent, restProps)}
              data={nodeProperties.data}
              nodeId={nodeProperties.id}
            />
          )
        );
      }}
    </Port>
  );
};

export default CustomPort;
